module.exports = class CsvTableCtrl
  constructor: ->
    'ngInject'
